module.exports = __webpack_public_path__ + "assets/img/1091587020817_.pic_hd.687480e5.jpg";